module.exports = (__parcel__import__("ehb4l")).then(() => parcelRequire('4MKVl'));